'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('flexDirection');


//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/~/styled-system/dist/flex-direction.js
// module id = 77
// module chunks = 35783957827783 64691314399603 114276838955818 228131777832141